import { IChatActionList, IChatActionsData } from "@core/base/chat-action-base";
import { chatConstants } from '@core/constants/chat.constants';
import type { ISkillQueueProgress } from '@core/office/office-chat/office-chat-v1/office-chat-v1';
import type { IChatMessage } from '@core/types/chat-message.types';
import type { IChatMessageResult } from '@core/types/chat.types';
import { Observable } from "rxjs";

export abstract class ChatBase
{
    public constants = chatConstants;
    public abstract getMessages(): Observable<IChatMessage[]>;
    public abstract getMessagesValue(): IChatMessage[];
    public abstract sendMessage(data: string, dataAction: IChatActionsData | null, actions: IChatActionList, retry?: boolean): Promise<IChatMessageResult>;
    public abstract sendMessageWithoutSaving(data: string, dataAction: IChatActionsData | null, actions: IChatActionList): Promise<IChatMessageResult>;
    public abstract clearMessages(): Promise<void>;
    public abstract writeBotMessage(text: string): Promise<void>;
    public abstract deleteMessage(index: number): Promise<void>;
    public abstract deleteLastUserMessage(): void;
    public abstract setHistoryForCurrentThread(enabled: boolean): Promise<boolean>;
    public abstract currentThreadId$(): Observable<string | null>;

    // Secondary threads of the same document. The AI tab uses the primary
    // conversation above; other views (e.g. the group chat's summaries) drive
    // their own thread, addressed by a scope — see THREAD_SCOPE.
    public abstract getThreadMessages(scope: string): Observable<IChatMessage[]>;
    public abstract $isThreadSending(scope: string): Observable<boolean>;
    public abstract initThread(scope: string): Promise<void>;
    public abstract sendMessageToThread(scope: string, text: string): Promise<IChatMessageResult>;

    public abstract $isLoading(): Observable<boolean>;
    public abstract $isMessagesLoading(): Observable<boolean>;
    public abstract $skillQueueProgress(): Observable<ISkillQueueProgress | null>;
    public onDestroy(): void { }
}
